import React, { useState, useEffect } from 'react';
/* eslint-disable camelcase */
// import core & vendor packages below
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';

// import components below
import ModalUI from 'components/UI/ModalUI';
import FormUI from 'components/UI/FormUI';

// import assets below
import './CreateDietaryMealModal.scss';
import { ReactComponent as CloseSVG } from 'assets/svg/circle-xmark.svg';
import { useDispatch, useSelector } from 'react-redux';
import { createPatientMeal, selectPatient } from 'reducers/patientReducer';
import { toast } from 'react-toastify';

// main componet
const CreateDietaryMealModal = (props) => {
  const dispatch = useDispatch();

  const { status, onToggle } = props;

  const groupState = useSelector(selectPatient);
  const { createdMeal, item } = groupState;
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    user_id: item?.id + '',
    diet_type: '',
  });

  const handleSubmit = () => {
    toast.info(`Creating Meal`);
    dispatch(createPatientMeal({ ...formData }));
    setIsSubmitted(true);
  };

  useEffect(() => {
    if (isSubmitted) {
      const { isFailed, isSuccess, error } = createdMeal;

      if (isFailed) {
        error?.map((error) => {
          toast.error(`${error.detail} (${error.code})`);
        });
      }

      if (isSuccess) {
        toast.info(`Meal created successfully`);
        onToggle(false);
        setIsSubmitted(false);
      }
    }
  }, [createdMeal]);

  const handleChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });

    return;
  };

  return (
    <div className='createDietaryModal'>
      <ModalUI>
        <Modal.Dialog>
          <Modal.Header>
            <h4>CREATE MEAL</h4>
            <Button onClick={() => onToggle(!status)} variant='transparent'>
              <CloseSVG />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className='createDietaryModal__content'>
              <FormUI>
                <Row>
                  <Col>
                    <Form.Group className='mb-3'>
                      <Form.Label>Diet Type</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Enter here'
                        onChange={handleChange('diet_type')}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </FormUI>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleSubmit} variant='addField' className='m-2'>
              Create
            </Button>
            <Button onClick={() => onToggle(!status)} variant='cancel'>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </ModalUI>
    </div>
  );
};

export default CreateDietaryMealModal;
